import { render } from "./PlatformList.vue?vue&type=template&id=0652cf8c"
import script from "./PlatformList.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformList.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/PlatformList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0652cf8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0652cf8c', __exports__)) {
    api.reload('0652cf8c', __exports__)
  }
  
  module.hot.accept("./PlatformList.vue?vue&type=template&id=0652cf8c", () => {
    api.rerender('0652cf8c', render)
  })

}


export default __exports__